<template>
  <div style="display: flex; flex-direction: column" :class="tem?.UI?.NoneNeedCallAction ? 'NoneNeedCallAction' : ''">
    <div
      v-for="model in tem.Values"
      v-if="model.IsShow && isShowValueType(model)"
      :key="model.KeyId"
      style="width: 100%; margin-bottom: 10px"
      :class="tem.ischeck || isIFTT ? '' : ' scence_ctr_NonJoin'"
    >
      <!-- 详情里有tip的才不可操作 自动化场景可以 -->
      <InnerSwitch
        v-if="isType(model, 'UIControl_Switch') || isType(model, 'UIControl_HCL_Switch') || isType(model, 'UIControl_TianMu_Loop') || isType(model, 'UIControl_TianMu_Loop_Group')"
        :name="tem.CnDesc || model.Name || tem.Desc"
        :device-model="deviceModel"
        :tem="tem"
        :batch-set-agriculture-channel-skus="batchSetAgricultureChannelSkus"
        :value="model.DefaultValue"
        :show-label="showLabel"
        :show-mode="showMode"
        :disabled="model.disabled || (!!tips && tipType === 1) "
        @click="handlerTipsToast"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      />
      <InnerRadioPlus
        v-else-if="model.ValueType == 'UIControl_Radio_Baoli'"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :enum-values="model.EnumValue"
        :disabled="model.disabled"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      />
      <InnerSlider
        v-else-if="isType(model, 'UIControl_SliderAndInput')"
        :max="model.Max"
        :min="model.Min"
        :type="model.Type"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            changeHandler(model, v)
          }
        "
      />
      <InnerSlider
        v-else-if="isType(model, 'UIControl_ChooseRange')"
        :max="model.Max"
        :min="model.Min"
        :range="true"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            changeHandler(model, v)
          }
        "
      />
      <InnerButton
        v-else-if="isType(model, 'UIControl_UpAndDown') || isType(model, 'UIControl_CCT')"
        :name="model.Name || tem.Desc"
        :enum-values="model.EnumValue"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @click="
          v => {
            doCallActionWrapper(model, v.Value, true)
          }
        "
      />
      <SliderWithInput
        v-else-if="isType(model, 'UIControl_TianMu_PlaybackSpeed')"
        :step="0.1"
        :max="model.Max / 10"
        :min="model.Min / 10"
        :type="model.ValueType"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      >
        <span
          slot="start"
          style="margin-right: 13px"
        >{{ model.Min / 10 }}</span>
        <span
          slot="end"
          style="margin-left: 13px"
        >{{ model.Max / 10 }}</span>
        <span
          v-if="model.Type != null && model.Type.indexOf('0x11') != -1"
          slot="after"
          class="lightUnit"
          style="margin-left: 4px"
        >
          {{ $t('tianmu.times') }}
        </span>
      </SliderWithInput>
      <SliderWithInput
        v-else-if="isType(model, 'UIControl_TianMu_PlaybackSpeed_Group')"
        :step="0.1"
        :max="model.Max / 10"
        :min="model.Min / 10"
        :type="model.ValueType"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      />
      <!-- <TianMuPlayer
        v-else-if="isType(model, 'UIControl_TianMu_Player')"
        :name="model.Name || tem.Desc"
        :enum-values="model.EnumValue"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @click="
          v => {
            doCallActionWrapper(model, v.Value, true)
          }
        "
      /> -->
      <SliderWithInput
        v-else-if="isType(model, 'UIControl_ColorTemperature') || isType(model, 'UIControl_ColorTemperature_SDL')"
        :class="model.Min == 1800 ? 'color_add color_add_1800' : 'color_add'"
        :max="model.Max"
        :min="model.Min"
        :type="model.ValueType"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      >
        <!-- <img
          slot="start"
          class="left_img"
          src="~@/assets/img/icon_set-01.png"
          alt="icon"
        >
        <img
          slot="end"
          class="right_img"
          src="~@/assets/img/icon_set-02.png"
          alt="icon"
        > -->
        <span
          v-if="model.Type != null && model.Type.indexOf('0x04') != -1"
          slot="after"
          class="lightUnit"
          style="margin-left: 4px"
        >K</span>
      </SliderWithInput>
      <SliderWithInput
        v-else-if="isType(model, 'UIControl_Bright')"
        class="light_add"
        :max="model.Max"
        :min="model.Min"
        :type="model.ValueType"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      >
        <!-- <img
          slot="start"
          class="left_img"
          src="~@/assets/img/icon_set-03.png"
          alt="icon"
        >
        <img
          slot="end"
          class="right_img"
          src="~@/assets/img/icon_set-04.png"
          alt="iconicon"
        > -->
        <span
          v-if="model.Type != null && model.Type.indexOf('0x03') != -1"
          slot="after"
          class="lightUnit"
          style="margin-left: 4px"
        >%</span>
      </SliderWithInput>
      <SliderWithInput
        v-else-if="isType(model, 'UIControl_Slider')"
        :max="model.Max"
        :min="model.Min"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        :type="model.ValueType"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      >
        <span
          v-if="model.Type != null && model.Type.indexOf('0x0F') != -1"
          slot="after"
          class="lightUnit"
          style="margin-left: 4px"
        >%</span>
        <span
          v-else
          slot="after"
          class="lightUnit"
          style="margin-left: 4px"
        >{{ model.ParaUnit }}</span>
      </SliderWithInput>
      <SliderWithInput
        v-else-if="isType(model, 'UIControl_MotorTrace_Slider') || isType(model, 'UIControl_MotorVerticalTrace_Slider')"
        class="light_add"
        :type="model.ValueType"
        :max="model.Max"
        :min="model.Min"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      >
        <!-- <img
          slot="start"
          class="left_img"
          src="~@/assets/img/icon_set-05.png"
          alt="icon"
        >
        <img
          slot="end"
          class="right_img"
          src="~@/assets/img/icon_set-06.png"
          alt="icon"
        > -->
        <span
          v-if="model.Type != null && model.Type.indexOf('0x0F') != -1"
          slot="after"
          class="lightUnit"
          style="margin-left: 4px"
        >%</span>
      </SliderWithInput>
      <SliderWithInput
        v-else-if="isType(model, 'UIControl_ColorTemperature_SDL_DUV')"
        class="duv_add"
        :type="model.ValueType"
        :max="model.Max"
        :min="model.Min"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      />
      <SliderWithInput
        v-else-if="isType(model, 'UIControl_MotorAngle_Slider')"
        :type="model.ValueType"
        :max="model.Max"
        :min="model.Min"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      >
        <!-- <img
          slot="start"
          class="left_img"
          src="~@/assets/img/icon_set-07.png"
          alt="icon"
        >
        <img
          slot="end"
          class="right_img"
          src="~@/assets/img/icon_set-08.png"
          alt="icon"
        > -->
        <span slot="after">°</span>
        <div slot="slider" class="slider_info">
          <span class="angle_span1">{{ $t('deviceMsg.uppage') }}</span>
          <span class="angle_span2">{{ $t('deviceMsg.downpage') }}</span>
        </div>
      </SliderWithInput>
      <InnerStartStop
        v-else-if="isType(model, 'UIControl_Motor_Stop')"
        stop
        :name="model.Name || tem.Desc"
        :show-label="showLabel"
        @click="v => doCallActionWrapper(model, v)"
      />
      <InnerText
        v-else-if="isType(model, 'UIControl_Text')"
        :name="model.Name"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @click="v => doCallActionWrapper(model, v,true)"
      />
      <InnerSelect
        v-else-if="isType(model, 'UIControl_DropdownList')"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :enum-values="model.EnumValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      />
      <InnerRadio
        v-else-if="isType(model, 'UIControl_RadioboxList') || isType(model, 'UIControl_TianMu_Player')"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :enum-values="model.EnumValue"
        :disabled="model.disabled"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      />
      <InnerStartStop
        v-else-if="isType(model, 'UIControl_StartAndStop')"
        :name="model.Name || tem.Desc"
        :show-label="showLabel"
        @click="v => doCallActionWrapper(model, v)"
      />
      <InnerInput
        v-else-if="isType(model, 'UIControl_Input')"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      />
      <InnerSelect
        v-else-if="isType(model, 'UIControl_MultipleDropdownList')"
        multiple
        collapse-tags
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :enum-values="model.EnumValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      />
      <InnerCheckbox
        v-else-if="isType(model, 'UIControl_CheckboxList')"
        :name="model.Name || tem.Desc"
        :enum-values="model.EnumValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v)
          }
        "
      />
      <InnerColorPicker
        v-else-if="isType(model, 'UIControl_ColorPanel')"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :is-monitor="isMonitor"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v, true)
          }
        "
      />
      <RgbColorPicker
        v-else-if="isType(model, 'UIControl_Color_RGB_WithMode')"
        :color="model.DefaultValue || ''"
        :is-need-auto-emit="isNeedAutoEmit"
        :model="model"
        :name="model.Name || tem.Desc"
        :show-label="showLabel"
        @change="v => {
          doCallActionWrapper(model, v, true)
        }"
      />
      <!-- <InnerColorPicker
        v-else-if="isType(model, 'UIControl_Color_RGB_WithMode')"
        :name="model.Name || tem.Desc"
        :value="model.DefaultValue"
        :is-monitor="isMonitor"
        :show-label="showLabel"
        @change="
          v => {
            const rgbs = v.slice(4, -1).split(', ').map(Number);

            const value = rgbToHex(...rgbs)
            //`${rgbs.map(color => color.toString(16).padStart(2, '0')).join('')}`

            doCallActionWrapper(model, value, true)
          }
        "
      /> -->

      <template v-else-if="model.ValueType == 'UIControl_RGB_Color_Multiple_Choose'">
        <RgbColorPickers
          :model="model"
          :config="model.UI"
          :name="model.Name || tem.Desc"
          :show-label="showLabel"
          @change="colorPickerUpdateValueChoose($event, model, tem)"
        />
      </template>
      <template v-else-if="UICONTROL_CX_CY_WithMode_ARRAY.includes(model.ValueType)">
        <ColorPicker
          v-if="tem.UI.extra && tem.UI.extra.matrix"
          :config="tem.UI.extra"
          :matrix="tem.UI.extra.matrix"
          :color="model.DefaultValue || ''"
          :model="model"
          :name="model.Name || tem.Desc"
          :show-label="showLabel"
          @change="colorPickerUpdateValue($event, model, tem)"
        />
      </template>
      <template v-else-if="UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY.includes(model.ValueType)">
        <ColorPickers
          v-if="model.UI.Extra && model.UI.Extra.matrix"
          :model="model"
          :config="model.UI"
          :name="model.Name || tem.Desc"
          :show-label="showLabel"
          @change="colorPickerUpdateValueChoose($event, model, tem)"
        />
      </template>
      <template v-else-if="model.ValueType == 'UIControl_Scene_Baoli'">
        <template v-if="isIFTT">
          <span class="scence_ctr_span_title">{{ model.Name || tem.Desc }}</span>
          <el-select
            v-model="model.DefaultValue"
            :placeholder="$t('deviceVirtual.placeholderone')"
            @change="
              v => {
                doCallActionWrapper(model, v)
              }
            "
          >
            <el-option
              v-for="child in model.EnumValue"
              :key="child.SceneId"
              :label="child.Name"
              :value="child.SceneId"
            />
          </el-select>
        </template>
        <SceneGroup
          v-else
          :model="model"
          :options="model.EnumValue"
          :name="model.Name || tem.Desc"
          :show-label="showLabel"
          @change="
            v => {
              doCallActionWrapper(model, v)
            }
          "
        />
      </template>
      <template v-else-if="model.ValueType == 'UIControl_Mode_ColorPick'">
        <ColorPicker
          :color="model.DefaultValue"
          :model="model"
          :config="{}"
          :matrix="0"
          :is-mode="true"
          :name="model.Name || tem.Desc"
          :show-label="showLabel"
          @change="colorPickerUpdateValue($event, model, tem)"
        />
      </template>
      <template v-else-if="model.ValueType == 'UIControl_Radiobox_Mode'">
        <ModeRadio
          :enum-values="model.EnumValue"
          :value="model.DefaultValue"
          :name="model.Name || tem.Desc"
          :show-label="showLabel"
          @change="
            v => {
              doCallActionWrapper(model, v)
            }
          "
        />
      </template>
      <ControlColor
        v-else-if="isType(model, 'UIControl_Color')"
        :name="model.Name || tem.Desc"
        :is-monitor="isMonitor"
        :value="model.DefaultValue"
        :show-label="showLabel"
        @change="
          v => {
            doCallActionWrapper(model, v, true)
          }
        "
      />
      <template v-else-if="model.ValueType == 'UIControl_TianMu_Video_Group' ">
        <TianMuVideo 
          :tem="tem"
          :model="model"
          :device-model="deviceModel"
          :device-card-list="deviceCardList"
          :PlanId="PlanId"
          :only-scene-no-list="onlySceneNoList"
          :is-edit-video-scene="isEditVideoScene"
          :selected-scene-no="selectedSceneNo"
          :show-mode="showMode"
          @click="
            v => {
              doCallActionWrapper(model, v, true)
            }
          "
          @clickPlayer="clickPlayer"
        />
      </template>
      <template v-else>
        <action-airCondition
          :tem="tem"
          :model="model"
          :action-list="[checkeddata]"
          :do-call-action="doCallAction"
          :do-callparam="[tem, item]"
          :no-lable="showLabel"
        />
      </template>
      <div v-if="tips" class="chooseItem-tip_container">
        <div class="chooseItem-tip">
          {{ model.Name }} {{ tips }}
        </div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="tips2"
          placement="top"
        >
          <div class="chooseItem-tip_radius">
            ?
          </div>
        </el-tooltip>
      </div>
      
      <!-- <div
        v-if="tem.Values.length>1"
        style="clear: both;overflow: hidden;"
      /> -->
    </div>
  </div>
</template>

<script>
import actionAirCondition from '@/components/common/actionAirCondition.vue'
import SwitchButton from '@/components/button/SwitchButton'
import InnerSwitch from '@/components/button/InnerSwitch'
import InnerSlider from '@/components/button/InnerSlider'
import SliderWithInput from '@/components/button/SliderWithInput'
import InnerButton from '@/components/button/InnerButton'
import InnerSelect from '@/components/button/InnerSelect'
import InnerCheckbox from '@/components/button/InnerCheckbox'
import InnerColorPicker from '@/components/button/InnerColorPicker'
import InnerInput from '@/components/button/InnerInput'
import InnerStartStop from '@/components/button/InnerStartStop'
import InnerText from '@/components/button/InnerText'
import InnerRadio from '@/components/button/InnerRadio'
import ColorPicker from '@/components/deviceAction/colorPicker/main.vue'
import RgbColorPicker from '@/components/button/RgbColorPicker.vue'
import RgbColorPickers from '@/components/button/RgbColorPickers.vue'
import ColorPickers from '@/components/deviceAction/colorPickers'
import SceneGroup from '@/components/button/SceneGroup.vue'
import InnerRadioPlus from '@/components/button/InnerRadioPlus.vue'
import ModeRadio from '@/components/button/ModeRadio.vue'
import { warning } from "@/assets/js/common.js";
import { rgbToHex } from '@/components/DesignCanvas/utils/common';
import TianMuVideo from '@/components/OppleTianMuVideo/TianMuVideo.vue'
import {UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY,UICONTROL_CX_CY_WithMode_ARRAY, PROJECTTYPE_ENUM} from '@/utils/enums'
import { FindConfigAbility } from '@/axios/IDevice';
import TianMuPlayer from '@/components/button/TianMuPlayer.vue'
import ControlColor from '@/components/button/ControlColor.vue'

//详情不展示的valueType
const NO_SHOW_VALUE_TYPE_DETAIL = ['UIControl_HCL_Switch']
export default {
  name: 'ChooseItem',
  components: {
    RgbColorPicker,
    actionAirCondition,
    SwitchButton,
    InnerSwitch,
    InnerSlider,
    SliderWithInput,
    InnerButton,
    InnerSelect,
    InnerCheckbox,
    InnerColorPicker,
    InnerInput,
    InnerText,
    InnerStartStop,
    InnerRadio,
    ColorPicker,
    ColorPickers,
    SceneGroup,
    InnerRadioPlus,
    ModeRadio,
    RgbColorPickers,
    TianMuPlayer,
    TianMuVideo,
    ControlColor
  },
  inject: {
    /** 是否为地图监控模式 */
    isMonitor: { default: false },
  },
  props: {
    isNeedAutoEmit: {
      type: Boolean,
      default: true,
    },
    tipType: {
      type: Number,
      default: -1,
    },
    gpDetails: {
      type: Array,
       default() {
        return []
      },
    },
    checkeddata: {
      type: Array,
      default() {
        return []
      },
    },
    tem: {
      type: Object,
      default() {
        return {}
      },
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
    isIFTT: {
      type: Boolean,
      default: false,
    },
    //是否显示name
    showLabel: {
      type: Boolean,
      default: true,
    },
    //是否是详情页面
    isDetail: {
      type: Boolean,
      default: false,
    },
    vDeviceId: {
      type: String,
      default: null
    },
    //天幕视频
    deviceCardList: {
      type: Array,
      default: () => [],
    },
    //天幕视频ID
    PlanId: {
      type: String,
      default: '',
    },
    //天幕设备信息
    deviceModel: {
      type: Object,
      default: () => ({}),
    },
    //天幕场景列表编辑
    isEditVideoScene:{
      type: Boolean,
      default: true
    },
    onlySceneNoList:{
      type: Boolean,
      default: false
    },
    selectedSceneNo:{
      type: Number,
      default: 0,
    },
    showMode: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      timr: null,
      controlReadyTimer: null,
      // 设备详情页控件初次渲染时 el-slider/el-select 等可能误触发 change
      controlReady: false,
      tips: '',
      tips2: '',
      UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY,
      UICONTROL_CX_CY_WithMode_ARRAY,
      batchSetAgricultureChannelSkus:{}
    }
  },
  watch: {
    gpDetails(val) {
      this.handlerTips();
    },

    tem(val) {
      this.handlerTips();
      if (this.isDetail) {
        this.resetControlReady()
      }
    },
  },
  mounted() {
    this.handlerTips();
    this.getChannelNameConfig()
    if (this.isDetail) {
      this.resetControlReady()
    } else {
      this.controlReady = true
    }
  },
  destroyed() {
    this.timr && clearTimeout(this.timr)
    this.controlReadyTimer && clearTimeout(this.controlReadyTimer)
  },
  methods: {
    getChannelNameConfig(){
      const ChannelNameConfig = this.$store.state.staticConfig.ChannelNameConfig
      this.batchSetAgricultureChannelSkus = {
        ClassSkus:Object.keys(ChannelNameConfig),
        isAgriculture: this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture
      }
    },
    rgbToHex(r, g, b) {
      return rgbToHex(r, g, b)
    },
    handlerTipsToast() {
      if (!!this.tips) {
        warning(this, this.tips);
      }
    },
    async handlerTips() {
      this.tips = '';

      if (this.tem.UI?.ActionDisabledBySettings && this.tem.UI?.ActionDisabledBySettings[0]) {
        const { Tips, Desc, AutoTips, AutoDesc, GpNo, KeyID, Value } = this.tem.UI?.ActionDisabledBySettings[0];

        let gpDetails = this.gpDetails || [];
        let vDeviceId = this.vDeviceId
        
        if ((!Array.isArray(gpDetails) || gpDetails.length === 0) && vDeviceId) {
          const res = await FindConfigAbility({
            vDeviceId
          });

          gpDetails =  res.Result?.GpList;
        }

        const data = gpDetails.find(item => item.GpNo === GpNo);

        if (!data) {
          this.tips = null;
          return
        }

        const detail = data.GpDetails.find(item => item.KeyId === KeyID);

        if (!detail) {
          this.tips = null;
          return
        }

        if ((Value || []).map(n => Number(n)).includes(Number(detail.DefaultValue))) {
          if (this.tipType === 1) {
            this.tips = Tips;
            this.tips2 = Desc;
          }

          if (this.tipType === 2) {
            this.tips = AutoTips;
            this.tips2 = AutoDesc;
          }
          
        }
      } else {
        this.tips = null;
      }
    },
    colorPickerUpdateValue(e, model) {
      model.DefaultValue = e
      this.doCallAction(this.tem, this.item, e, '', model)
    },
    colorPickerUpdateValueChoose(e, model, data) {
      if (e.canChange) {
        model.DefaultValue = e.value
        this.doCallAction(data, this.item, e.value, '', model)
      }
    },
    isType(model, type) {
      return model.ValueType === type
    },
    changeHandler(model, v) {
      this.dataFormatInt(false, model, 'DefaultValue', model, 'Type', '0x03')
      this.doCallActionWrapper(model, v)
    },
    /**
     * 数据格式化
     * @param model action value 对象
     * @param _type 修改的值
     * @param isColor 是否颜色(之前的属性,保留)
     * @param {Boolean} force 是否强制下发
     */
    doCallActionWrapper(model, _type,force = false) {
      if (_type === model.DefaultValue && !force) return // 避免模版场景中同一控制默认值对设备影响
      model.DefaultValue = _type
      this.doCallAction(this.tem, this.item, _type, false, model)
    },
    clickPlayer({action, v}){
      const model = action.Values.find(item=>item.IsShow)
      model.DefaultValue = v
      this.$emit('do-call-action', {...action, fromWhere:'lightLibrary'})
    },
    /**
     * 修改后回调
     * @param {*} tem 整个action
     * @param {*} model  设备信息
     * @param {*} _type  修改的值
     * @param {*} isColor 是否颜色
     * @param {*} value  action中values中的一个
     */
    resetControlReady() {
      this.controlReady = false
      this.controlReadyTimer && clearTimeout(this.controlReadyTimer)
      // ChooseItem.doCallAction 有 500ms debounce，略大于该值即可
      this.controlReadyTimer = setTimeout(() => {
        this.controlReady = true
      }, 600)
    },
    doCallAction(tem, model, _type, isColor, value) {
      // if(this.tem?.UI?.NoneNeedCallAction) return; // 不需要调用action
      if (this.isDetail && !this.controlReady) return
      if (this.timr) clearTimeout(this.timr)
      this.timr = setTimeout(() => {
        this.$emit('do-call-action', tem, model, _type, isColor, value)
        clearTimeout(this.timr)
      }, 500)
    },
    //是否展示valueType
    isShowValueType(model) {
      if (this.isDetail) {
        return NO_SHOW_VALUE_TYPE_DETAIL.indexOf(model.ValueType) === -1
      }
      return true
    },
  },
}
</script>
<style lang="scss" scoped>
.color-item {
  float: left;
  margin-right: 10px;
  margin-bottom: 20px;
}
.scence_ctr_span {
  margin-left: 0;
  text-align: center;
  color: #303030;
  height: -webkit-max-content;
  height: -moz-max-content;
  height: max-content;
}
.two_switch {
  display: flex;
}
.NoneNeedCallAction ::v-deep .scence_ctr_span_title {
  // visibility: hidden;
}
</style>
<style>
.duv_add .el-slider__runway {
  background: linear-gradient(to right, #ef8a7f, #fafcfe, #d8d8d8);
}
.duv_add .el-slider__bar {
  background-color: transparent;
}
.color_add_1800 .el-slider__runway {
  background: linear-gradient(90deg, #ff9900 0%, #ffd89c 13%, #fffaf1 27%, #f5f9ff 38%, #bbd6ff 100%) !important;
}
.color_add .el-slider__runway {
  background: linear-gradient(90deg, #ff7e00 0%, #ffe36d 9%, #fffaf1 33%, #faf9f8 38%, #f5f9ff 44%, #bbd6ff 100%);
}
.lightUnit {
  width: 8px;
}
.chooseItem-tip_container {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.chooseItem-tip {
  display: inline-block;
  padding: 2px 4px;
  margin-right: 10px;
  border-radius: 3px;
  border: 1px solid #FF7E05;
  color: #FF7E05;
  font-size: 12px;
  line-height: 14px;
}
.chooseItem-tip_radius {
  width: 18px;
  height: 18px;
  line-height: 18px;
  border-radius: 50%;
  text-align: center;
  background-color: #d0d0d0;
}
</style>
